var map = {
	"./bernerzeitung.png": "ef10",
	"./bfs.png": "e45d",
	"./britannica-academic.png": "70ca",
	"./britannica-imagequest.png": "fbdf",
	"./brockhaus.png": "4512",
	"./derbund.png": "94e2",
	"./digithek.gif": "affd",
	"./dokumentARfilm.jpg": "eb30",
	"./duden.png": "b4d4",
	"./filmdienst.gif": "30ad",
	"./fwu.png": "4dc2",
	"./geistundgehirn.png": "92f0",
	"./harenberg.gif": "3bcd",
	"./kdg.jpg": "e0d5",
	"./keystone.jpg": "79c5",
	"./kindler.gif": "7adb",
	"./klfg.jpg": "b5f7",
	"./klg.jpg": "1724",
	"./lip.png": "161d",
	"./mediothek.gif": "0d07",
	"./munzinger-chronik.png": "6f97",
	"./munzinger-laender.png": "57d2",
	"./munzinger-personen.png": "d0ed",
	"./republik.png": "2373",
	"./roempp.gif": "af31",
	"./sda.gif": "bbd3",
	"./spektrum.png": "e8dc",
	"./spektrum_woche.png": "851a",
	"./swissdox.gif": "97c4",
	"./wissenschaft-online.gif": "8d04"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3f63";